(function () {
  'use strict';

  // The mobile drawer toggle is owned by the compiled bundle and animates over
  // 0.5s. Re-tapping mid-transition can desync its open/close state (the icon
  // shows "open" while the drawer isn't). Swallow re-taps in the capture phase
  // until the drawer settles, so the bundle handler only sees one toggle.
  const LOCK_MS = 520;

  const guard = (button) => {
    if (!button || button.dataset.tapGuard) return;
    button.dataset.tapGuard = '1';
    let lockedUntil = 0;
    button.addEventListener(
      'click',
      (event) => {
        const now = Date.now();
        if (now < lockedUntil) {
          event.stopImmediatePropagation();
          event.preventDefault();
          return;
        }
        lockedUntil = now + LOCK_MS;
      },
      true
    );
  };

  const init = () => document.querySelectorAll('.hamburger').forEach(guard);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
